import StakingManage from './index';
import OrderManage from './orderManage';
import PairConfig from './pairConfig';
import PrimaryConfig from './primaryConfig';
import IncomeDistribution from './incomeDistribution';
import LockAndUnlockStatistics from './lockAndUnlockStatistics';

export default {
    path: '/home/staking',
    component: StakingManage,
    children: [
        {path: '/home/staking/primary/config', component: PrimaryConfig},
        {path: '/home/staking/pair/config', component: PairConfig},
        {path: '/home/staking/order', component: OrderManage},
        {path: '/home/staking/incomeDistribution', component: IncomeDistribution},
        {path: '/home/staking/lockAndUnlock/statistics', component: LockAndUnlockStatistics}
    ]
};
